import { defineStore } from 'pinia';
import { strapi } from '../transport/strapi';
import type { IPaymentAlertData, IPaymentAlertStrapiResponse } from '~/types/alerts';

export const useStorePaymentAlerts = defineStore('paymentAlerts', {
  state: () => ({
    data: [] as IPaymentAlertData[],
    requestPromise: null as Promise<IPaymentAlertStrapiResponse> | null,
  }),
  actions: {
    async loadAlerts() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('payment-alerts')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        this.data = response.data;

        return true;
      } else {
        return false;
      }
    },
  },
});
